module.exports = __webpack_public_path__ + "ar.no1.cdaccff2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ar.no1.jpg
// module id = cZY/
// module chunks = 0